module.exports = __webpack_public_path__ + "img/storycity_logo_text.1ab1a2eb.svg";